import React, { useState } from 'react';
import { Tabs, Button, Space } from 'antd';
import type { TabsProps } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FullscreenOutlined } from '@ant-design/icons';
import SimpleRuleBuilder from './SimpleRuleBuilder';
import AIRuleGenerator from './AIRuleGenerator';
import VisualRuleBuilder from './VisualRuleBuilder';
import { PATH } from 'constants/path';
import s from './s.module.less';

const DecisionTree: React.FC = () => {
    const [activeTab, setActiveTab] = useState<string>('manual');
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const assessmentUuid = searchParams.get('uuid') || '';

    const handleOpenVisualFlowBuilder = () => {
        const url = `${PATH.OPERATION}/${PATH.VISUAL_FLOW_BUILDER}?uuid=${assessmentUuid}`;
        navigate(url);
    };

    const tabItems: TabsProps['items'] = [
        {
            key: 'manual',
            label: 'Manual Configuration',
            children: <SimpleRuleBuilder />,
        },
        // {
        //     key: 'visual',
        //     label: <Space>Visual Flow Builder</Space>,
        //     children: (
        //         <Button
        //             onClick={handleOpenVisualFlowBuilder}
        //         >
        //             Open in Full Screen
        //         </Button>
        //     ),
        // },
        {
            key: 'ai',
            label: 'AI Rule Generation',
            children: <AIRuleGenerator />,
        },
    ];

    return (
        <div className={s.decisionTree}>
            <SimpleRuleBuilder />
            {/* <Tabs
                activeKey={activeTab}
                onChange={setActiveTab}
                items={tabItems}
                className={s.tabs}
            /> */}
        </div>
    );
};

export default DecisionTree;
